(function () {
  const DUR = 450;
  const easeOut = (t) => 1 - Math.pow(1 - t, 3);
  const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));
  const lerp = (a, b, t) => a + (b - a) * t;

  function init(root) {
    const row = root.querySelector('[data-drv-lstories-row]');
    const items = [...root.querySelectorAll('[data-drv-lstories-item]')];
    if (!row || !items.length) return;
    if (items.length < 2) { items[0].setAttribute('data-d', '0'); return; }

    const dots = [...root.querySelectorAll('[data-drv-lstories-dot]')];
    const n = items.length;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let pos = 0;
    let goal = 0;
    let raf = null;
    let geo = null;

    const measure = () => {
      const cs = getComputedStyle(row);
      const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const num = (name) => {
        const raw = cs.getPropertyValue(name).trim();
        const value = parseFloat(raw) || 0;
        return raw.endsWith('rem') ? value * rem : value;
      };
      const w0 = num('--w0'), w1 = num('--w1'), w2 = num('--w2'), h0 = num('--h0');
      const minGap = num('--drv-learn-stories-min-gap');
      const widths = [w2, w1, w0, w1, w2];
      const sum = widths.reduce((a, b) => a + b, 0);
      let gap = num('--slotgap');
      let start = 0;
      if (gap > 0) {
        start = (row.clientWidth - (sum + gap * 4)) / 2;
      } else {
        gap = (row.clientWidth - sum) / 4;
        if (gap < minGap) {
          gap = minGap;
          start = (row.clientWidth - (sum + gap * 4)) / 2;
        }
      }
      const xs = [];
      let acc = start;
      widths.forEach((w) => { xs.push(acc); acc += w + gap; });
      geo = {
        x: [xs[0] - w2 - gap, xs[0], xs[1], xs[2], xs[3], xs[4], xs[4] + w2 + gap],
        w: [w2, w2, w1, w0, w1, w2, w2],
        h: [w2, w2, w1, h0, w1, w2, w2],
        pitch: (xs[4] - xs[0]) / 4,
      };
    };

    const at = (table, r) => {
      const c = clamp(r, -3, 3) + 3;
      const lo = Math.floor(c);
      const hi = Math.ceil(c);
      return lerp(table[lo], table[hi], c - lo);
    };

    const relOf = (i, p) => {
      const r = i - p;
      return r - n * Math.round(r / n);
    };

    const paint = (p) => {
      items.forEach((el, i) => {
        const r = relOf(i, p);
        const w = at(geo.w, r);
        el.style.transform = 'translate(' + at(geo.x, r) + 'px, -50%)';
        el.style.width = w + 'px';
        const media = el.querySelector('.drv-lstories__media');
        if (media) { media.style.width = w + 'px'; media.style.height = at(geo.h, r) + 'px'; }
        el.style.opacity = String(clamp((2.5 - Math.abs(r)) / 0.5, 0, 1));
        el.setAttribute('data-d', String(Math.min(Math.round(Math.abs(r)), 3)));
      });
    };

    const syncDots = (index) => {
      const active = ((Math.round(index) % n) + n) % n;
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === active);
        if (dot.tagName === 'BUTTON') dot.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
    };

    const settle = (index) => {
      pos = ((index % n) + n) % n;
      goal = pos;
      paint(pos);
      items.forEach((el, i) => {
        const video = el.querySelector('video');
        if (video) { Math.round(relOf(i, pos)) === 0 ? video.play().catch(() => {}) : video.pause(); }
      });
    };

    const animateTo = (target) => {
      goal = target;
      cancelAnimationFrame(raf);
      syncDots(target);
      if (reduced) { settle(target); return; }
      const from = pos;
      const delta = target - from;
      const t0 = performance.now();
      const tick = (now) => {
        const t = Math.min(1, (now - t0) / DUR);
        pos = from + delta * easeOut(t);
        paint(pos);
        if (t < 1) raf = requestAnimationFrame(tick);
        else settle(target);
      };
      raf = requestAnimationFrame(tick);
    };

    const step = (dir) => animateTo(goal + dir);

    root.querySelector('[data-drv-lstories-prev]')?.addEventListener('click', () => step(-1));
    root.querySelector('[data-drv-lstories-next]')?.addEventListener('click', () => step(1));

    dots.forEach((dot, i) => dot.addEventListener('click', () => {
      let diff = i - (((goal % n) + n) % n);
      diff -= n * Math.round(diff / n);
      animateTo(goal + diff);
    }));

    root.addEventListener('click', (e) => {
      const t = e.target.closest('[data-drv-lstories-toggle]');
      if (!t) return;
      const video = t.parentElement.querySelector('video');
      if (!video) return;
      if (video.paused) video.play().catch(() => {});
      else video.pause();
    });

    items.forEach((el) => {
      const video = el.querySelector('video');
      const btn = el.querySelector('[data-drv-lstories-toggle]');
      if (!video || !btn) return;
      const sync = () => {
        btn.classList.toggle('is-paused', video.paused);
        btn.setAttribute('aria-label', video.paused ? btn.dataset.labelPlay : btn.dataset.labelPause);
      };
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      sync();
    });

    let dragging = false;
    let startX = 0;
    let basePos = 0;
    let moved = false;

    row.addEventListener('pointerdown', (e) => {
      if (e.target.closest('a, button')) return;
      if (e.pointerType === 'mouse') {
        if (e.button !== 0) return;
        e.preventDefault();
      }
      cancelAnimationFrame(raf);
      dragging = true;
      moved = false;
      startX = e.clientX;
      basePos = pos;
      row.classList.add('is-dragging');
      try { row.setPointerCapture(e.pointerId); } catch (err) {}
    });

    row.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 5) moved = true;
      pos = basePos + -dx / geo.pitch;
      paint(pos);
    });

    const endDrag = (e) => {
      if (!dragging) return;
      dragging = false;
      row.classList.remove('is-dragging');
      try { row.releasePointerCapture(e.pointerId); } catch (err) {}
      animateTo(Math.round(pos));
    };

    row.addEventListener('pointerup', endDrag);
    row.addEventListener('pointercancel', endDrag);
    row.addEventListener('click', (e) => {
      if (!moved) return;
      moved = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    let wheelSum = 0;
    let wheelLocked = false;
    let wheelIdle = 0;
    row.addEventListener('wheel', (e) => {
      if (e.ctrlKey || Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      clearTimeout(wheelIdle);
      wheelIdle = setTimeout(() => { wheelSum = 0; wheelLocked = false; }, 200);
      if (wheelLocked) return;
      wheelSum += e.deltaMode === 1 ? e.deltaX * 16 : e.deltaX;
      if (Math.abs(wheelSum) < 30) return;
      wheelLocked = true;
      step(wheelSum > 0 ? 1 : -1);
    }, { passive: false });

    let resizeTimer;
    const relayout = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => { measure(); paint(pos); }, 120);
    };
    window.addEventListener('resize', relayout);
    if (window.ResizeObserver) new ResizeObserver(relayout).observe(row);

    row.classList.add('is-ready');
    measure();
    settle(0);
    syncDots(0);
  }

  const boot = () => document.querySelectorAll('[data-drv-lstories]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
